<div class="grid-track" [class.fluid]="fluid()" [class.fixed]="!fluid()" data-testid="asset-grid_track">
    @for (item of items(); track item.referenceId; let i = $index) {
        <asset-card
            [item]="item"
            [attr.data-testid]="cardTestId()"
            [attr.data-reference-id]="item.referenceId"
            [displayFormat]="displayFormat()"
            [size]="size()"
            [fluid]="fluid()"
            [topChart]="topChart()"
            [index]="i"
            (openDetails)="onItemClick($event)">
        </asset-card>
    }
</div>
